<div *ngIf="data$.countries as countries" style="overflow: hidden">
  <div [ngClass]="customClass" *ngIf="countries[data]">
    <img *ngIf="countries[data].img" src="{{ countries[data].img }}" width="20" height="20" />
    &nbsp;&nbsp;{{ data }}&nbsp;&nbsp;
    <ng-container *ngIf="length; else fullStr">
      <span class="text-color text-color--gray" p500UITooltip [tooltipData]="countries[data].name" [longContent]="true"
        >/ &nbsp;
        {{ countries[data].name.length > length ? (countries[data].name | slice: 0:length) + '...' : countries[data].name }}
      </span>
    </ng-container>
    <ng-template #fullStr>
      <span class="text-color text-color--gray"
        >/ &nbsp;
        {{ countries[data].name }}
      </span>
    </ng-template>
  </div>
  <div [ngClass]="customClass" *ngIf="!countries[data] && !nullIsEmpty">
    <span class="text-color text-color--green" i18n="@@common.all_countries">All Countries</span>
  </div>
  <div [ngClass]="customClass" *ngIf="!countries[data] && nullIsEmpty">
    <span class="c-field-value__text -light-gray"> Empty </span>
  </div>
</div>
